import { Model, Factory, belongsTo } from 'miragejs'
import {
  rand,
  randNumber,
  randPastDate,
  randCountry,
  randCity,
  randZipCode,
} from '@ngneat/falso'
import type { MockServer } from './server'
import type { ModelDefinition } from 'miragejs/-types'

type DevPlaygroundPatientBillingInvoice = {
  invoice_number: number
  invoice_date: string
  country: string
  city: string
  zip_code: string
  department_name: string
}

export const model = Model.extend({
  billing: belongsTo('devPlaygroundPatientBilling'), // Define the relationship
}) as ModelDefinition<DevPlaygroundPatientBillingInvoice>

export const factory = Factory.extend<DevPlaygroundPatientBillingInvoice>({
  invoice_number: () =>
    randNumber({
      min: 10000000000,
      max: 99999999999,
    }),
  invoice_date: () => randPastDate().toISOString(),
  country: () => randCountry(),
  city: () => randCity(),
  zip_code: () => randZipCode(),
  department_name: () =>
    rand([
      'Bath Clinic',
      'Ocean Beach Clinic',
      'Park Animal Hospital',
      'Balboa Pet Hospital',
    ]),
})

export function routes(server: MockServer) {
  server.resource('devPlaygroundPatientBillingInvoice')
}
